import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=1ce362de&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&id=1ce362de&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce362de",
  null
  
)

export default component.exports